import React, { useEffect, useState } from "react";
import InlineAudioPlayer from '@/shared/components/InlineAudioPlayer';

export default function DraftAudioPreview({ audioBlob, recordingTime = 0 }) {
  const [objectUrl, setObjectUrl] = useState("");

  useEffect(() => {
    if (!audioBlob) return;
    const fresh = new Blob([audioBlob], { type: audioBlob.type || "audio/webm" });
    const url = URL.createObjectURL(fresh);
    setObjectUrl(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [audioBlob]);

  if (!audioBlob) return null;

  if (!objectUrl) {
    return (
      <div
        className="h-9 w-full max-w-full rounded-md bg-amber-100/80 animate-pulse"
        aria-hidden
      />
    );
  }

  return (
    <InlineAudioPlayer
      src={objectUrl}
      variant="draft"
      knownDurationSeconds={recordingTime}
    />
  );
}
